var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.onSeason)?_c('img',{staticClass:"seasonal-christmas-navigation",attrs:{"alt":"","src":require("../../assets/images/sidebar_christmas.png")}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }